import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { BulletStyle, BulletType } from '../../themes/theme';
import { WidgetType } from '../../utils/widgetsUtils';

export enum ListItemStyle {
  Regular = 'regular',
  Wrapped = 'wrapped'
}

export enum BulletPosition {
  Start = 'start',
  Top = 'top'
}

const ListItemSchema = z.object({
  id: z.string(),
  fragment: ProseMirrorJSONSchema
});

export const StyledBulletListWidgetStaticSchema = BaseWidgetSchema(WidgetType.StyledBulletList).extend({
  children: z.array(z.string()).optional(), // `children` is optional because it is not used in the StyledBulletList's `create` function
  listItems: z.array(ListItemSchema),
  listItemStyle: z.nativeEnum(ListItemStyle),
  bullet: z
    .object({
      type: z.nativeEnum(BulletType).optional(),
      color: z.string().optional(),
      number: z.nativeEnum(BulletStyle).optional(),
      letter: z.nativeEnum(BulletStyle).optional(),
      icon: z.string().optional()
    })
    .partial(),
  adjustBulletToTextSize: z.boolean(),
  numberOfColumns: z.number(),
  bulletPosition: z.nativeEnum(BulletPosition),
  style: z.record(z.unknown())
});

export type StyledBulletListWidgetStaticSchemaType = z.infer<typeof StyledBulletListWidgetStaticSchema>;
